import React from 'react';
import { APP_VERSION, formatVersionDate } from '../../config/version';

const Footer = ({ className = '' }) => {
  return (
    <footer className={`mt-8 pt-4 border-t border-slate-200 text-center ${className}`}>
      <p className="text-xs text-slate-400">
        Version {APP_VERSION.version} • Mise à jour le {formatVersionDate(APP_VERSION.buildDate)}
      </p>
    </footer>
  );
};

export default Footer;
